define('collections/reseller_products',['require','collections/base','models/reseller_product'],function(require){

    var BaseCollection = require('collections/base');
    var Model = require("models/reseller_product");

    return BaseCollection.extend({
        model: Model,
        url: 'reseller-products.json'
    });
});

